import { memo, useState } from 'react'

import { BlankSlate, Box, List, Section } from '@factorialco/deprecated-design-system'
import { SecuritySettingsDomainSectionFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import SettingsGroup from 'modules/security_settings/components/SettingsGroup'

import { AddDomainModal } from './AddDomainModal/AddDomainModal'
import { DomainListItem } from './DomainListItem'

interface Props {
  domains: SecuritySettingsDomainSectionFragment[]
}

function DomainSection({ domains }: Props) {
  const [showAddDomainModal, setShowAddDomainModal] = useState(false)
  const [showInstructionsModal, setShowInstructionsModal] = useState(false)
  const [selectedDomainId, setSelectedDomainId] = useState<string | null>(null)

  return (
    <Section.TwoThirds
      illustration={undefined}
      title={i18n.t('security_settings.domain.title')}
      description={i18n.t('security_settings.domain.description')}
      action={{
        label: i18n.t('security_settings.domain.action'),
        onClick: () => setShowAddDomainModal(true),
      }}
    >
      {domains.length === 0 ? (
        <SettingsGroup>
          <Box alignItems="center" justifyContent="center" width="full" style={{ height: '10vh' }}>
            <BlankSlate
              illustration="wireframe"
              size="small"
              title={i18n.t('security_settings.domain.blank_slate.title')}
              description={i18n.t('security_settings.domain.blank_slate.description')}
            />
          </Box>
        </SettingsGroup>
      ) : (
        <List>
          {domains.map((domain) => (
            <DomainListItem
              key={domain.id}
              domain={domain}
              showInstructions={showInstructionsModal && selectedDomainId === domain.id}
              onShowInstructions={() => {
                setSelectedDomainId(domain.id)
                setShowInstructionsModal(true)
              }}
              onCloseInstructions={() => {
                setSelectedDomainId(null)
                setShowInstructionsModal(false)
              }}
            />
          ))}
        </List>
      )}
      {showAddDomainModal && (
        <AddDomainModal
          onClose={() => setShowAddDomainModal(false)}
          onSuccess={(newDomain) => {
            setSelectedDomainId(newDomain.id)
            setShowAddDomainModal(false)
            setShowInstructionsModal(true)
          }}
        />
      )}
    </Section.TwoThirds>
  )
}

export default memo(DomainSection)
